import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../stores/Hooks';
import { StatementStatusEnum } from '../models/StatementStatusEnum';

export const StatementHelpComponent: React.FC<any> = observer(
	() =>
	{
		const { uiState } = useStores();

		return (
			<>
				{
					uiState.StatementStatus === StatementStatusEnum.Created &&
					<div className="statement-step-info">
						<p>Заявление сформировано.<br /> Подпишите квалифицированной электронной подписью руководителя организации (действующего от имени организации без доверенности).</p>
						<p>Обращаем внимание, что подписание электронной подписью является юридически значимым действием.</p>
						<p className="mb-0">Сведения об операторе ЭДО <br /> и документы возможно изменить после подписания заявления,<br /> при этом заявление будет удалено.</p>
					</div>
				}
				{
					uiState.StatementStatus === StatementStatusEnum.Signed &&
					<div className="statement-step-info">
						<p>Заявление готово к отправке <br /> в ФНС России. Убедитесь, что все сведения об операторе ЭДО<br />и документы указаны правильно.</p>
						<p className="mb-0">Информация о приложенных документах и сведения об операторе ЭДО будут доступны для просмотра 2 месяца после регистрации обращения.</p>
					</div>
				}
				{
					uiState.StatementStatus === StatementStatusEnum.Sent &&
					<div className="statement-step-info">
						<p>Подписанный пакет документов оптравлен на рассмотрение<br />в ФНС России.</p>
						<p className="mb-0">В ближайшее время на адрес электронной почты для <br /> обратной связи, указанной Вами <br /> при регистрации, будет <br /> направлено уведомление о регистрации <br /> с идентификационным номером <br /> обращения.</p>
					</div>
				}
				{
					uiState.StatementStatus === StatementStatusEnum.Received &&
					<div className="statement-step-info">
						<p>Подписанный пакет документов принят на рассмотрение в ФНС России.</p>
						<p className="mb-0">Решение по заявлению оператора ЭДО будет сформировано и направлено в течение 30 календарных дней на адрес электронной почты для обратной связи, указанной Вами при регистрации.</p>
					</div>
				}
			</>
		);
	}
)
